import { useCallback, useState } from 'react';

export type Tema = 'claro' | 'escuro';
const CHAVE = 'metaepi.tema';

function temaAtual(): Tema {
  return document.documentElement.classList.contains('dark') ? 'escuro' : 'claro';
}

/** Alterna claro/escuro e lembra a escolha neste navegador (se o armazenamento estiver disponível). */
export function useTema(): { tema: Tema; alternar: () => void } {
  const [tema, setTema] = useState<Tema>(temaAtual);

  const alternar = useCallback(() => {
    const novo: Tema = temaAtual() === 'escuro' ? 'claro' : 'escuro';
    document.documentElement.classList.toggle('dark', novo === 'escuro');
    try {
      localStorage.setItem(CHAVE, novo);
    } catch {
      // navegação privada ou armazenamento bloqueado: a escolha vale só nesta visita
    }
    setTema(novo);
  }, []);

  return { tema, alternar };
}
